import "./WhatsAppFloat.scss";
import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

// Base del API de Functions (fetch plano SIN token — el endpoint
// /whatsappFloatV2/public es público). Mismo mecanismo que Footer.js.
const API_BASE = process.env.REACT_APP_API_URL;

/**
 * Botón flotante "click-to-chat" de WhatsApp (wa.me). Se muestra SOLO si el
 * super-admin lo activó (enabled === true) y hay un número. Config gestionada en
 * WhatsappFlotanteV2 (capacidad publicRoutes). Si el fetch falla, no renderiza
 * nada (el botón es opcional; sin fallback).
 */
export const WhatsAppFloat = () => {
    const [config, setConfig] = useState(null); // { enabled, phone, message } | null

    useEffect(() => {
        if (!API_BASE) return;
        let cancelled = false;
        fetch(`${API_BASE}/whatsappFloatV2/public`)
            .then((res) => (res.ok ? res.json() : null))
            .then((data) => {
                if (cancelled || !data || !data.enabled || !data.phone) return;
                setConfig({ phone: data.phone, message: data.message || "" });
            })
            .catch(() => { /* opcional: no renderiza si falla */ });
        return () => { cancelled = true; };
    }, []);

    if (!config || !config.phone) return null;

    const href = `https://wa.me/${config.phone}` +
        (config.message ? `?text=${encodeURIComponent(config.message)}` : "");

    return (
        <a
            className="wa-float"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Escríbenos por WhatsApp"
        >
            <FaWhatsapp />
        </a>
    );
};

export default WhatsAppFloat;
